export const KNOWLEDGE_BASE_URL =
  'https://knowledge-base.yieldbird.com/prebid-stack/vendor-specific-prebid-modules'
